<template>
    <div class="loginWrap">
        <header class="header">
            <a href="/"><img src="../../assets/logo-header.svg" alt="" class="logo"/></a>
            <nav>
                <a href="/" class="back">返回首页</a>
                <span class="line"></span>
                <a href="/about.html" class="about">关于我们</a>
            </nav>
        </header>
        <div class="loginBox">
            <div class="loginContent">
                <div class="banners">
                    <a href="/product.html"><img src="../../assets/login_pic.png" alt=""/></a>
                </div>
                <div class="contentWrap">
                    <div class="loginConText loginContentText" v-if="!scanLogin">
                        <div class="content">
                            <div class="scanCode" @click="wechatScan"></div>
                            <img src="../../assets/scan-tips.png" alt="" class="scanTips"/>
                            <h1>欢迎登录QuickLive</h1>
                            <input
                                    type="text"
                                    maxlength="11"
                                    v-model.trim="phone"
                                    ref="phoneInput"
                                    v-bind:class="phoneClass"
                                    placeholder="请输入手机号"
                            />
                            <input
                                    type="password"
                                    v-model.trim="password"
                                    ref="passwordInput"
                                    v-bind:class="passwordClass"
                                    placeholder="请输入密码"
                            />
                            <div class="item" id="awsc" v-if="!scanLogin"></div>
                            <div class="passwordBox">
                                <div></div>
                                <a @click="jumpPage('/forget')">忘记密码</a>
                            </div>
                            <button v-bind:class="logonBtnClass" id="btn-login">登录</button>
                            <span class="registerTips">没有账号？<a href="https://www.quicklive.net.cn/reg">我要免费注册</a></span>
                        </div>
                    </div>
                    <div class="loginConText scanLoginContent" v-if="scanLogin">
                        <div class="content">
                            <div class="normalLogin" @click="accountLogon"></div>
                            <h1>扫码登录QuickLive</h1>
                            <div class="scanLoginQrcodeBox">
                                <img :src="qrCodeData" alt="正在获取二维码" class="loginQrcode"/>
                                <span>请使用微信扫描二维码登录</span>
                            </div>
                            <span class="registerTips"
                            >没有账号？<a href="https://www.quicklive.net.cn/reg">我要免费注册</a></span
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
                title="完成认证"
                :visible.sync="verifyVisible"
                width="366px">
            <div>您的账号尚未完成实名认证，无法正常登录，请使用微信扫描以下二维码完成认证，完成后重新登录。</div>
            <div><img :src="verifyQrData" style="width: 100%"></div>
            <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="verifyVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <footer class="footer">
            <dl class="first">
                <dl class="aboutUs">
                    <dl>
                        <dt><a href="javascript:;">直播场景</a></dt>
                        <dd><a href="/case.html?case=0" target="_blank">大型活动</a></dd>
                        <dd><a href="/case.html?case=1" target="_blank">企业培训</a></dd>
                        <dd><a href="/case.html?case=2" target="_blank">营销宣传</a></dd>
                        <dd><a href="/case.html?case=3" target="_blank">VR全景直播</a></dd>
                        <dd><a href="/case.html?case=4" target="_blank">多平台推拉流</a></dd>
                        <dd><a href="/case.html?case=5" target="_blank">多会场云导播</a></dd>
                    </dl>
                    <dl>
                        <dt><a href="javascript:;">技术支持</a></dt>
                        <dd><a href="/guide.html" target="_blank">直播百科</a></dd>
                        <dd><a href="#" target="_blank">软件下载</a></dd>
                    </dl>
                    <dl>
                        <dt><a href="javascript:;">购买服务</a></dt>
                        <dd><a href="/buy.html?buy=0" target="_blank">硬件购买</a></dd>
                        <dd><a href="/buy.html" target="_blank">流量套餐</a></dd>
                    </dl>
                    <dl>
                        <dt><a href="javascript:;">关于我们</a></dt>
                        <dd><a href="/about.html?about=0" target="_blank">复全网络</a></dd>
                        <dd><a href="/about.html?about=2" target="_blank">联系我们</a></dd>
                    </dl>
                    <div class="introduce">
                        <div class="title">
                            <img src="../../assets/logo-footer.png" alt class="logo"/>
                            <span class="line"></span>
                            <span>企业直播平台</span>
                        </div>
                        <p class="desc">
                            QuickLive是专业的企业级云直播平台，拥有多终端超清直播和点播、互动分享、个性化设置、数据统计等100+优质功能，可为政府、企业、教育机构等各类用户提供低成本、高质量的一站式视频直播和点播服务。
                        </p>
                        <div class="key">电话</div>
                        <div class="value">021-60135568-608</div>
                        <div class="key">邮箱</div>
                        <a class="value email"
                           href="mailto:service@fortune-net.cn"
                           target="_blank">service@fortune-net.cn</a>
                        <div class="key">地址</div>
                        <div class="value">上海市杨浦区佳木斯路353号1502室</div>
                        <div class="public">
                            <img src="../../assets/public-qrcode.png" alt class="qrcode"/>
                            <span>QuickLive公众号</span>
                        </div>
                    </div>
                </dl>
            </dl>
            <div class="second">
                <div class="solution">
                    <h2 class="title">我们还提供其他解决方案</h2>
                    <div>
                        <a href="/about.html?about=1" class="item firstItem" target="_blank"
                        >音视频采集分类管理系统 Redex Pro></a
                        >
                        <a href="/about.html?about=1" class="item" target="_blank"
                        >学员培训记录考核管理系统 SmartTraining></a
                        >
                    </div>
                </div>
            </div>
            <div class="last">
                <div class="copyright">
                    <span class="firstItem">Copyright © 2017 Fortune Network All rights reserved.</span>
                    <span>上海复全网络技术有限公司 沪B2-20220918</span>
                </div>
            </div>
            <div class="footerRight">
                <div class="contactCustomerService">联系客服</div>
                <div class="gotoTopBtn" @click="goTop"></div>
            </div>
        </footer>
    </div>
</template>
<script>
    const AWSC_SCENE = 'mdcab0v2';
    const AWSC_PREFIX = '1r2b1e';
    import common from '../../common.vue';

    const LOGON_RESULT = {
        LOGON_RESULT_SUCCESS : 1,
        LOGON_RESULT_WRONG_PASSWORD : 2,
        LOGON_RESULT_WRONG_TIMES_EXCEED : 10,
        LOGON_RESULT_NOT_FACE_VERIFIED : 11,
    }
    const SCAN_RESULT = {
        SUCCESS : 1,
        WAITING : 0,
        FAILED : 2
    }
    let LOGON_RESULT_MAPPER = {
        '0': "验证信息无效",
        '1': "登录成功",
        '2': "密码错误",
        '3': "账号不存在",
        '9': "账号已被锁定",
        '10': "账号因错误次数过多被暂时锁定",
        '99': "登录信息不完整"
    }

    export default {
        props: {},
        data() {
            return {
                scanLogin: false,
                loading: false,
                phone: "",
                password: "",
                phoneClass: "loginInput",
                passwordClass: "loginInput",
                logonBtnClass: "loginBtn",
                // 登录二维码数据
                qrCodeData: null,
                // 获取登录状态的timer
                timer: null,
                verifyQrData: null,
                verifyVisible: false,
                // 验证码
                captcha: null,
                // 验证码参数
                verifyParams: null
            };
        },
        computed: {},
        created() {
        },
        mounted() {
            this.initAwsc();
            this.$refs.phoneInput.focus();
        },
        watch: {
            phone(){
                this.phoneClass = (this.phone === ''? "loginInput error": "loginInput");
            },
            password(){
                this.passwordClass = (this.password === ''? "loginInput error": "loginInput");
            }
        },
        methods: {
            initAwsc() {
                let _this = this;
                window.initAliyunCaptcha({
                    SceneId: AWSC_SCENE,
                    prefix: AWSC_PREFIX,
                    mode: 'popup',
                    element: '#awsc',
                    button: '#btn-login',
                    captchaVerifyCallback: (verifyParams) =>{
                        _this.verifyParams = verifyParams;
                        return _this.doLogon();
                    },
                    onBizResultCallback: (bizResult) =>{
                        console.log(bizResult);
                    },
                    getInstance: (instance) =>{ _this.captcha = instance },
                    slideStyle: { width: 400, height: 45},
                    language: 'cn',
                    region: 'cn'
                })
            },
            goTop() {
                document.querySelector("body").scrollTop = 0;
            },
            jumpPage(path) {
                this.$router.push(`${path}`);
            },
            checkInput(){
                if(!!this.loading || this.logonBtnClass.indexOf('disabled') >= 0){ return; }

                if(!common.phoneValid(this.phone)){
                    this.$message({
                        message: '请输入正确的手机号',
                        type: 'warning'
                    });
                    this.phoneClass = "loginInput error";
                    return false;
                }
                if(this.password === ''){
                    this.$message({
                        message: '请输入密码',
                        type: 'warning'
                    });
                    this.passwordClass = "loginInput error";
                    return false;
                }
                // if(!this.verifyParams) {
                //     this.$message({
                //         message: '请完成人机验证',
                //         type: 'warning',
                //         duration: 1200,
                //         onClose: () => {
                //             //window.nc.reset();
                //         }
                //     });
                //     return false;
                // }
                return true;
            },
            doLogon: async function(){
                if(!this.checkInput()){ return; }
                let _this = this, nonce = (new Date()).getTime(), logonData = {
                    nonce : nonce,
                    phone: _this.phone,
                    password: this.$md5(this.$md5(_this.password) + nonce),
                    sceneId: AWSC_SCENE,
                    verifyParams: _this.verifyParams
                };
                //请求登录接口
                _this.loading = true;
                let captchaResult = true, bizResult = true;
                await _this.$axios.post(common.LOGON_URL, this.$qs.stringify(logonData)).then(function (res) {
                    // 显示登录结果
                    _this.loading = false;
                    _this.showLogonResult(res.data);
                    captchaResult = (res.data.code !== 10001);
                    bizResult = (res.data.code === LOGON_RESULT.LOGON_RESULT_SUCCESS);
                });
                return {captchaResult: captchaResult, bizResult: bizResult};
            },
            showLogonResult(result){
                let code = parseInt(result.code);
                if(code === LOGON_RESULT.LOGON_RESULT_SUCCESS){
                    setTimeout(() => {
                        this.jumpPage('/index');
                    }, 1000);
                }else{
                    // window.nc.reset();
                    if(code === LOGON_RESULT.LOGON_RESULT_NOT_FACE_VERIFIED){
                        // 未完成实人认证，提示后，显示二维码继续，不侦测认证状态
                        this.showVerifyCode(result.sponsorId);
                    }else{
                        // 密码错误和错误次数过多特殊处理，其他统一显示失败原因，重置人机验证
                        let message = LOGON_RESULT_MAPPER["" + code];
                        if(code === LOGON_RESULT.LOGON_RESULT_WRONG_PASSWORD){
                            let failedTimes = result.wrongTimes, maxTimes = result.maxTimes;
                            if(failedTimes && maxTimes){
                                if(parseInt(failedTimes) >= parseInt(maxTimes)){
                                    this.logonBtnClass = "loginBtn disabled";
                                    message = '账号密码错误，已连续错误' + failedTimes + '次，请' + Math.ceil(parseFloat(result.duration)/60.0) + '分钟后重试';
                                }else{
                                    message = '账号密码错误，已连续错误' + failedTimes + '次，还有' + ( parseInt(maxTimes) - parseInt(failedTimes)) + '次尝试机会';
                                }
                            }
                        }else if(code === LOGON_RESULT.LOGON_RESULT_WRONG_TIMES_EXCEED){
                            if(result.duration){
                                message = '该账号因登录失败次数过多，被暂时锁定，请' + Math.ceil(parseFloat(result.duration)/60.0) + '分钟后重试';
                            }else{
                                message = '该账号因登录失败次数过多，被暂时锁定，请稍后再试';
                            }
                        }
                        this.$message({
                            message: message,
                            type: 'warning',
                            duration: 2800
                        });
                    }
                }
            },
            /**
             * 显示实人认证二维码
             */
            showVerifyCode(sid){
                let _this = this;
                _this.$axios.post(common._BASE_ + 'sponsor/faceVerifyQr', this.$qs.stringify({sponsorId: sid})).then(function (res) {
                    let data = res.data;
                    // 显示登录结果
                    if(parseInt(data.code) === 0){
                        _this.verifyQrData = 'data:image/png;base64,'+ data.qrCode;
                        _this.verifyVisible = true;
                    }
                });
            },

            /**
             * 切换至账号密码登录
             */
            accountLogon(){
                this.scanLogin = false;
                this.timer && clearInterval(this.timer);
                document.querySelector('.sm-btn-wrapper').style.display = 'block';
            },
            /**
             * 切换至微信扫描登录
             */
            wechatScan(){
                let _this = this;
                _this.scanLogin = true;
                // 这个ali的傻B控件不会自己隐藏
                document.querySelector('.sm-btn-wrapper').style.display = 'none';
                // 请求二维码
                _this.$axios.post(common._BASE_ + '/sponsor/logonQrCode').then(function (res) {
                    let r = res.data;
                    if(r && r.code === 0 && r.qrCode){
                        _this.qrCodeData = r.qrCode;
                        _this.timer = setInterval(function(){
                            _this.queryScanStatus(r.scene);
                        }, 1000);
                    }
                });
            },
            /**
             * 查询扫描状态
             * @param scene
             */
            queryScanStatus(scene){
                let _this = this;
                _this.scanLogin = true;
                // 请求二维码
                _this.$axios.post(common._BASE_ + '/sponsor/logonStatus',
                    this.$qs.stringify({sceneId: scene})).then(function (res) {
                    let r = res.data;
                    if(r){
                        if(r.code === SCAN_RESULT.SUCCESS){
                            clearInterval(_this.timer);
                            _this.jumpPage('/index');
                        }else if(r.code === SCAN_RESULT.FAILED){
                            clearInterval(_this.timer);
                            _this.$notify({
                                title: '失败',
                                message: '登录失败，无效的用户或用户被锁定',
                                type: 'error'
                            });
                            _this.scanLogin = false;
                        }
                    }
                });
            }
        },
        components: {},
    };
</script>
<style scoped lang="less">
    .header {
        width: 100%;
        height: 60px;
        padding: 0 19px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        font-weight: 400;
        color: #707070;
        background: #fff;
        a {
            color: #707070;
        }
        a:hover {
            color: #306ff6;
        }
        a.back {
            margin-right: 17px;
        }
        a.about {
            margin-left: 17px;
        }
        .line {
            display: inline-block;
            height: 14px;
            width: 1px;
            background: #c1c5c5;
        }
        .logo {
            width: 152px;
            cursor: pointer;
        }
    }

    .footer {
        height: 470px;
        background: #33363f;
        position: relative;
    }

    .footer .first {
        height: 327px;
        border-bottom: 1px solid #55565f;
        padding-top: 28px;
    }

    .footer .second {
        height: 92px;
        border-bottom: 1px solid #55565f;
    }

    .footer .last {
        height: 51px;
    }

    .footer .aboutUs,
    .footer .solution,
    .footer .copyright {
        width: 1000px;
        height: 100%;
        margin: 0 auto;
    }

    .footer .aboutUs {
        display: flex;
        position: relative;
    }

    .footer .aboutUs dl {
        width: 74px;
        margin-right: 48px;
        dd {
            margin-left: 0;
        }
    }

    .footer .aboutUs dl:last-child {
        margin-right: 0;
    }

    .footer .aboutUs dl dt > a {
        display: inline-block;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: #f5f6f7;
        margin-bottom: 10px;
        cursor: pointer;
    }

    .footer .aboutUs dt:hover,
    .footer .aboutUs dl a:hover,
    .footer .introduce .email:hover,
    .footer .solution .item:hover {
        color: #f5f6f7;
        text-decoration: underline;
    }

    .footer .aboutUs dl a {
        font-size: 12px;
        font-weight: 400;
        line-height: 26px;
        color: #a2a9ab;
    }

    .footer .introduce {
        width: 412px;
        position: absolute;
        right: 0;
    }

    .footer .introduce .title {
        font-size: 20px;
        font-weight: 400;
        line-height: 20px;
        color: #ffffff;
        display: flex;
        align-items: center;
    }

    .footer .introduce .title .logo {
        width: 207px;
    }

    .footer .introduce .title .line {
        width: 1px;
        height: 34px;
        background: #707070;
        margin: 0 9px;
    }

    .footer .introduce .desc {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        color: #a2a9ab;
        margin-top: 16px;
        margin-bottom: 19px;
    }

    .footer .introduce .key {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        color: #a2a9ab;
    }

    .footer .introduce .value {
        font-size: 12px;
        font-weight: 400;
        line-height: 24px;
        color: #f5f6f7;
    }

    .footer .introduce .public {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 12px;
        font-weight: 400;
        line-height: 24px;
        color: #ffffff;
        position: absolute;
        right: 0;
        top: 153px;
    }

    .footer .introduce .public .qrcode {
        width: 91px;
    }

    .footer .solution {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .footer .solution .title {
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        color: #f5f6f7;
        margin-bottom: 10px;
    }

    .footer .solution .item {
        font-size: 12px;
        font-weight: 400;
        line-height: 24px;
        color: #a2a9ab;
    }

    .footer .solution .item.firstItem {
        margin-right: 50px;
    }

    .footer .copyright {
        line-height: 51px;
        font-size: 12px;
        font-weight: 400;
        color: #7e868c;
        text-align: center;
    }

    .footer .copyright .firstItem {
        margin-right: 27px;
    }

    .footerRight {
        width: 34px;
        height: 134px;
        position: fixed;
        right: 0;
        bottom: 8%;
        .contactCustomerService {
            position: absolute;
            width: 34px;
            height: 98px;
            background: #4aa3f8;
            opacity: 1;
            border-radius: 4px 0px 0px 4px;
            right: 0;
            top: 0;
            padding: 16px 10px;
            font-size: 14px;
            font-weight: 400;
            line-height: 16px;
            color: #ffffff;
            cursor: pointer;
        }

        .contactCustomerService:hover {
            background: #306ff6;
        }

        .gotoTopBtn {
            position: absolute;
            width: 34px;
            height: 30px;
            right: 0;
            bottom: 0;
            background: #55565f;
            opacity: 1;
            border-radius: 4px 0px 0px 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            background: url(../../assets/gotoTopBtn1.svg) no-repeat center center;
        }

        .gotoTopBtn:hover {
            background: url(../../assets/gotoTopBtn2.svg) no-repeat center center;
        }
    }

    .loginBox {
        width: 100%;
        height: 880px;
        background: linear-gradient(180deg, #b4d9ff 0%, #f5f5ff 100%);
        padding-top: 116px;
        font-size: 14px;
    }

    .loginContent {
        width: 1000px;
        height: 650px;
        background: #076eff;
        margin: 0 auto;
        position: relative;
    }

    .banners {
        width: 500px;
        height: 650px;
        position: absolute;
        top: 0;
        left: 0;
    }

    .contentWrap {
        width: 500px;
        height: 650px;
    }

    .content {
        width: 500px;
        height: 650px;
        background: #fff;
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 110px;
    }

    .scanCode {
        width: 47px;
        height: 47px;
        position: absolute;
        right: 8px;
        top: 7px;
        cursor: pointer;
        background: url(../../assets/scan-code.png) no-repeat center center;
        background-size: 100% 100%;
    }

    .scanCode:hover {
        background: url(../../assets/scan-code.svg) no-repeat center center;
        background-size: 100% 100%;
    }

    .normalLogin {
        width: 33px;
        height: 33px;
        position: absolute;
        right: 8px;
        top: 7px;
        cursor: pointer;
        background: url(../../assets/normal-login.png) no-repeat center center;
        background-size: 100% 100%;
    }

    .normalLogin:hover {
        background: url(../../assets/normal-login.svg) no-repeat center center;
        background-size: 100% 100%;
    }

    .scanTips {
        width: 133px;
        position: absolute;
        right: 46px;
        top: 22px;
    }

    .loginInput {
        width: 400px;
        height: 45px;
        border: 1px solid #c0c5c5;
        font-size: 14px;
        margin-bottom: 17px;
        padding-left: 14px;
    }

    .loginInput.error {
        border: solid 1px #f89191;
        color: #f89191;
    }

    .content h1 {
        font-size: 24px;
        font-weight: bold;
        color: #33363f;
        margin-bottom: 21px;
    }

    .passwordBox {
        width: 400px;
        height: 22px;
        display: flex;
        justify-content: space-between;
    }

    .passwordBox div {
        display: flex;
        align-items: center;
    }

    .passwordBox input {
        width: 20px;
        height: 20px;
        border: solid 1px #c1c5c5;
        border-radius: 4px;
        cursor: pointer;
        margin-right: 8px;
    }

    .loginInput:focus {
        border: 1px solid #306ff6;
    }

    .loginBox a {
        color: #076eff;
    }

    .loginBox a:hover {
        border-bottom: #306ff6 solid 1px;
    }

    .passwordBox .checked {
        background: url(../../assets/checked_login.svg) no-repeat center center;
        background-size: 100% 100%;
        border: none;
    }

    .loginBtn {
        width: 400px;
        height: 50px;
        background: #076eff;
        border-radius: 4px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        margin-top: 23px;
    }

    .loginBtn:hover {
        background: #4aa3f8;
    }

    .registerTips {
        margin-top: 17px;
    }

    .scanLoginQrcodeBox {
        width: 309px;
        height: 344px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #333f44;
        background: url("../../assets/scan-login-bg.png") no-repeat center center;
        background-size: 100% 100%;
    }

    .scanLoginQrcodeBox .loginQrcode {
        width: 291px;
    }

    .scanLogin {
        display: none;
    }

    button.disabled{
        background: gainsboro;
        cursor: not-allowed;
    }
</style>
